import { useEffect, useState } from 'react';
import '../css/process.css'
import { useNavigate } from "react-router-dom";
import config from '../Context/Config';
import Background from '../Components/background/background';

const ProcessPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getFormInfo();
    },[]);


    const getFormInfo = async () => {
        setLoading(true);
        
        try {

            // Make API call to get form information
            const response = await fetch(`${config.API_BASE_URL}/form_info`, {
                method: "GET",
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": config.accessToken || ""
                },
            });

            if (!response.ok) {
                if (response.status === 400) {
                    await showErrorAlert("Invalid authorization code. Please try logging in again.");
                } else if (response.status === 401) {
                    await showErrorAlert("Authentication failed. Please try logging in again.");
                } else if (response.status >= 500) {
                    await showErrorAlert("Server error. Please try again later.");
                } else {
                    await showErrorAlert("Authentication failed. Please try again.");
                }
                return;
            }

            const message = await response.json();
            config.practice = message['practice'];

            
            navigate(`/${message['formType']}`, { state: { openedViaLogin: true, show: message['show'] === "true" ? true : false,  show_pcm: message['show_pcm'] === "true" ? true : false,  show_finance: message['show_finance'] === "true" ? true : false } });
            
            
        } catch (error) {
            // Only log detailed errors in development
            if (process.env.NODE_ENV === 'development') {
                console.error("Error in getFormInfo:");
            }

            await showErrorAlert("Unable to complete authentication. Please try again.");
        } finally {
            setLoading(false);
        }
    };

       const clearAuthData = () => {
        config.accessToken = null;
        config.token = null;
        config.practice = null;
    };

      const showErrorAlert = async (message = "An unexpected error occurred. Please try again later.") => {
            const Swal = (await import('sweetalert2')).default;
            Swal.fire({
                icon: "error",
                title: "Authentication Error",
                text: message,
                confirmButtonText: "Return to Login",
                allowOutsideClick: false
            }).then(() => {
                clearAuthData();
                navigate("/");
            });
        };
    

    return (
        <div className="relative h-screen w-screen bg-white overflow-hidden">
            {/* Animated Background */}
            <Background />

            {/* Loading Indicator */}
            {loading && (
                <div className="absolute inset-0 flex justify-center items-center z-10">
                    <div className="cloud"></div>
                </div>
            )}
        </div>
    );
};

export default ProcessPage;